import { Me } from '@iw/core/entities';

export function userMock(): Me {
  return {
    id: '24234df33r23er2',
    email: 'mockUser@example.com',
    address: '123 Mock Street',
    agreementDate: 1704067200,
    agreementNumber: 'AG12345',
    city: 'Mock City',
    country: 'Mock Country',
    createdAt: '2025-01-01T00:00:00Z',
    district: 'Mock District',
    division: 'Mock Division',
    documentsLink: 'http://mockDocuments.com',
    firstName: 'Mock',
    fullName: 'Mock User',
    isKycPassed: true,
    kycLink: 'http://mockKyc.com',
    lastName: 'User',
    organizationId: 'ORG123',
    phone: '+1234567890',
    registrationNumber: 'REG12345',
    state: 'Mock State',
    tariff: 'Mock Tariff',
    status: 'active',
    taxNumber: 'TAX12345',
    tradeName: 'Mock Trade',
    type: 'individual',
    updatedAt: '2025-01-01T00:00:00Z',
    zip: '12345',
    salaryCurrency: 'USD',
    contractType: 'employment',
    convertedCurrency: 'EUR',
    location: {
      id: 'LOC123',
      country: 'Mock Country',
      symbolicName: 'MC',
      divisionName: 'Mock Division',
      availableCurrencies: ['USD', 'EUR', 'GBP'],
    },
    roles: ['iiiwallet.dev.superuser', 'iiiwallet.dev.user'],
    avatar: 'http://mockAvatar.com/avatar.png',
  };
}
